var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('b-tabs',{attrs:{"nav-wrapper-class":"nav-border nav nav-pills"},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title-link-class":[
      'font-weight-semibold',
      'border-top-0',
      'border-right-0',
      'border-left-0'
    ],"lazy":"","title":"Se connecter"}},[_c('login-tab')],1),_c('b-tab',{attrs:{"title-link-class":[
      'font-weight-semibold',
      'border-top-0',
      'border-right-0',
      'border-left-0'
    ],"lazy":"","title":"S'inscrire"}},[_c('register-tab',{on:{"goToTab":_vm.goToTab}})],1),_c('modal-success',{attrs:{"id":"email-sent","title":"Un e-mail vous a été envoyé."}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"font-weight-semibold font-22 mb-2"},[_vm._v(" Bienvenue à "),_c('span',[_vm._v("Stark")])])}]

export { render, staticRenderFns }